import { Type } from "../Type";
const criteriaFunctions = {
    positive: {
        is: (value) => value > 0,
        condition: "> 0",
    },
    negative: {
        is: (value) => value < 0,
        condition: "< 0",
    },
    integer: {
        is: (value) => Number.isInteger(value),
        condition: "Number.isInteger",
    },
};
export function number(criteria) {
    const [isFunction, condition] = criteria == undefined ? [undefined, undefined] : fromCriteria(criteria);
    return new IslyNumber(isFunction, condition);
}
function fromCriteria(criteria) {
    return typeof criteria == "number"
        ? [value => value == criteria, " == " + criteria.toString()]
        :
            ((c) => Array.isArray(c) && c.every(c => typeof c == "number"))(criteria)
                ? [value => criteria.map(fromCriteria).some(c => c[0](value)), criteria.join(" | ")]
                :
                    ((c) => Array.isArray(c) && c.every(c => typeof c == "string" && c in criteriaFunctions))(criteria)
                        ? [
                            value => criteria.map(fromCriteria).every(c => c[0](value)),
                            criteria
                                .map(fromCriteria)
                                .map(c => c[1])
                                .join(" & "),
                        ]
                        :
                            typeof criteria === "function"
                                ? [criteria, "custom"]
                                :
                                    criteria in criteriaFunctions
                                        ? [criteriaFunctions[criteria].is, criteriaFunctions[criteria].condition]
                                        :
                                            [() => false, "Unknown criteria"];
}
export class IslyNumber extends Type {
    isFunction;
    class = "number";
    constructor(isFunction, condition) {
        super("number", condition);
        this.isFunction = isFunction;
    }
    is = (value) => typeof value == "number" &&
        !Number.isNaN(value - value) &&
        (!this.isFunction || this.isFunction(value));
}
//# sourceMappingURL=index.js.map